import type { FlagConfiguration } from '@atlassian/jira-flags';
import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	componentAdditionFailedTitle: {
		id: 'project-components.flags.component-addition-failed-title',
		defaultMessage: "We couldn't create the component.",
		description:
			"Flag's title - appears when component couldn't be added. For example: user is offline.",
	},
	componentAdditionFailedDescription: {
		id: 'project-components.flags.component-addition-failed-description',
		defaultMessage: 'Something went wrong. Try again.',
		description:
			"Flag's description - appears when component couldn't be added. For example: user is offline.",
	},
});

const AddError = (): FlagConfiguration => ({
	type: 'error',
	isAutoDismiss: false,
	title: messages.componentAdditionFailedTitle,
	description: messages.componentAdditionFailedDescription,
	messageId: 'project-directories.components.flags.add.flag.error',
	messageType: 'transactional',
});

export default AddError;
